import * as React from 'react';
import { Controlled_BooleanInputProps } from '../../../../../../../react-commons/components/inputs/controlled/Controlled_BooleanInput';
import { ControlledInputs } from '../../../../../../../react-commons/utils/read-only-inputs/controlledInputs';
import { usePropertyInfo } from '../../../../hooks/usePropertyInfo';
import { PropertyValidationInformation } from '../../../../util/PropertyValidationInformation';

export const Controlled_PropertyBooleanInput = ({
    readOnly,
    labelOverride,
    propertyValidationInformation: { propertyIdentifier, resourceType, resourceId },
    hideLabel,
    ...props
}: Omit<Controlled_BooleanInputProps<false>, 'label' | 'labelInfo' | 'severity' | 'helperText' | 'nullable'> & {
    labelOverride?: string;
    propertyValidationInformation: PropertyValidationInformation;
    hideLabel?: boolean;
}) => {
    const propertyInfo = usePropertyInfo({
        propertyIdentifier,
        resourceType,
        resourceId,
        hideLabel,
        labelOverride,
        readOnly,
    });

    return <ControlledInputs.Boolean
        nullable={false}
        {...propertyInfo}
        {...props}
    />;
};